export default __webpack_public_path__ + "static/media/Vazir-Medium.4fcac616.woff";